var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMist({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    fill: "#87cefa",
    viewBox: "0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#87cefa"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#87cefa",
    d: "M27.271,45.757h21.77c0.136,0.011,0.266,0.041,0.404,0.041c2.757,0,4.992-2.235,4.992-4.993s-2.235-4.993-4.992-4.993 c-2.758,0-4.993,2.235-4.993,4.993c0,0.958,0.283,1.843,0.751,2.603H27.271c-0.648,0-1.174,0.526-1.174,1.175 S26.623,45.757,27.271,45.757z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.004,57.818c-0.034-0.002-0.063-0.02-0.098-0.02h-27.9c-0.648,0-1.175,0.526-1.175,1.175s0.526,1.175,1.175,1.175 h23.582c-0.482,0.768-0.772,1.669-0.772,2.643c0,2.757,2.235,4.993,4.993,4.993c2.757,0,4.992-2.235,4.992-4.993 C60.801,60.101,58.668,57.923,56.004,57.818z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.912,48.4c0-2.757-2.235-4.993-4.992-4.993c-2.758,0-4.993,2.235-4.993,4.993c0,0.974,0.29,1.875,0.772,2.643H27.37 c-0.649,0-1.175,0.526-1.175,1.175s0.525,1.175,1.175,1.175h39.647c0.035,0,0.063-0.017,0.098-0.02 C69.779,53.268,71.912,51.09,71.912,48.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMist);
export default __webpack_public_path__ + "static/media/mist.212df11cebffa663c362a05c2c5eca25.svg";
export { ForwardRef as ReactComponent };